import { UGCList } from "../../../../../models/home-rows";
import { FileType, UGCType } from "../models/funUgc.model";

export const GetUgcFileType = async (ugc: UGCList): Promise<FileType> => {
  if (!ugc) return null;

  switch (ugc.ugc_type) {
    case UGCType.Dub:
      return "Dub";
    case UGCType.Story:
      return "Story";
    case UGCType.Painting:
      return "Painting";
    case UGCType.Coloring:
      return "Coloring";
    case UGCType.Gallery:
      return "Gallery";
    case UGCType.Dubsmash:
      return "Dubsmash";
    default:
      break;
  }
};
